const Keys = {
    namespaced: true,
    state : {
        private : "MIIBVQIBADANBgkqhkiG9w0BAQEFAASCAT8wggE7AgEAAkEA5PLHRWx0+e3vvQyce22XjUjBFTjLNZhYaAlIyc4fiO7KPfzVwNZb542QJ/da4jJgX5QWDb7efjPUfqax4kje8wIDAQABAkAXCDl1yXhnIEGq8hbX7+l8JCKQgPsodCAIr05sRtkzTCnEL3PRb0NULXAILEHpmcXdRKsusgYvQzwWZ5P7mP5pAiEA885mItuebcxnm1ESIRjq1uAq/+hu7fg0+UKZL1FQ700CIQDwZiULx4zH4ZLnEftk0HmbyNq4v2qyioWyNM4CbG5nPwIgBKV9WtK2rT8FBnfAEbNo3ll9WE00uAJP+CQlyToSgc0CIQCdOzGfsrRxRyg92ZUDKxdevM/RZeDzRYaMN91F2IWdIQIhAKxrFwDISiU4pkoXV2ZLDgjP3D/FrMN06QhO5qsTis1P",
        public  : "MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAOTyx0VsdPnt770MnHttl41IwRU4yzWYWGgJSMnOH4juyj381cDWW+eNkCf3WuIyYF+UFg2+3n4z1H6mseJI3vMCAwEAAQ=="
    },
}
export default Keys;